module.exports = __webpack_public_path__ + "static/building-blocks-7fd36d5164f0cb897fcc6a3f1f3ae062.svg";